import { render, staticRenderFns } from "./category-box.vue?vue&type=template&id=0757489b&scoped=true&lang=pug&"
import script from "./category-box.vue?vue&type=script&lang=js&"
export * from "./category-box.vue?vue&type=script&lang=js&"
import style0 from "./category-box.vue?vue&type=style&index=0&id=0757489b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0757489b",
  null
  
)

export default component.exports